import React from 'react';
import { combineReducers } from 'redux-immutable';
import { Provider } from 'react-redux';
import { storeFactory } from './store';
import { withTranslation, I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import 'antd/dist/reset.css';
import './styles/main.css';

import * as reducers from './reducers';
import classifiersStore from './utils/classifiersStore';
import { Spin } from 'antd';
import RootComponent from './Root';
import axios from 'axios';

const reducer = combineReducers({
  ...reducers,
});

const store = storeFactory(reducer);

class App extends React.Component {
  state = {
    classifiersLoading: true,
  };

  componentDidMount = async () => {
    if (!i18n.isInitialized) {
      i18n.on('initialized', this.initApp);
    } else {
      // In dev, i18n may already be initialized (e.g. HMR / Fast Refresh in React 18+)
      // So we call initApp() immediately if ready.
      this.initApp();
    }
  };

  componentWillUnmount() {
    i18n.off('initialized', this.initApp);
  }

  initApp = async () => {
    const lang = i18n.resolvedLanguage || i18n.language;
    axios.defaults.headers.common.lang = lang;

    await classifiersStore.update();

    this.setState({ classifiersLoading: false });
  };

  render() {
    if (this.state.classifiersLoading) {
      return <Spin />;
    }

    return (
      <I18nextProvider i18n={i18n}>
        <Provider store={store}>
          <RootComponent />
        </Provider>
      </I18nextProvider>
    );
  }
}

export default withTranslation('common')(App);
